import { Component, ElementRef, HostListener, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { EmpresasService } from '../../../../shared/services/empresas.service';
import { MarcaService } from '../../../../shared/services/marca.service';
import { PropietarioService } from '../../../../shared/services/propietarios.service';
import { TiposService } from '../../../../shared/services/tipos.service';
import { VehiclesService } from '../../../../shared/services/vehicles.service';
import { RelacionService } from '../../../../shared/services/relacion.service';
import { ModelosService } from '../../../../shared/services/modelos.service';
import { CombustibleService } from '../../../../shared/services/combustible.service';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { NgbAccordion, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgbdSortableHeader } from '../../../../shared/directives/NgbdSortableHeader';
import { TipoServicioService } from '../../../../shared/services/tiposervicio.service';
import { TiposerviciosDocumentosService } from '../../../../shared/services/tiposerviciosdocumento.service';
import { TipoPeriodoService } from '../../../../shared/services/tipo-periodo.service';
import { AdministracionService } from '../../../../shared/services/administracion.services';
import { forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthService } from '../../../../shared/services/auth.service'
import { DataService } from '../../../../shared/services/municipios.service';
declare var require: any;
const Swal = require('sweetalert2')

@Component({
  selector: 'app-nuevo',
  templateUrl: './nuevo.component.html',
  styleUrls: ['./nuevo.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NuevoComponent implements OnInit {

  modoCreacion: 'manual' | 'runt' = 'manual';

  @ViewChild('inputServicio') inputServicio!: ElementRef;
  @ViewChild('inputPlaca') inputPlaca!: ElementRef;
  @ViewChild('inputInterno') inputInterno!: ElementRef;
  @ViewChild('inputAfiliacion') inputAfiliacion!: ElementRef;
  @ViewChild('inputEmpresa') inputEmpresa!: NgSelectComponent;
  @ViewChild('inputClase') inputClase!: NgSelectComponent;
  @ViewChild('inputMarca') inputMarca!: NgSelectComponent;
  @ViewChild('inputModelo') inputModelo!: NgSelectComponent;
  @ViewChild('inputRelacion') inputRelacion!: NgSelectComponent;
  @ViewChild('inputPassword') inputPassword!: ElementRef;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  @ViewChild('inputNumeroTarjeta') inputNumeroTarjeta!: ElementRef;
  @ViewChild('inputFechaExpedicionTarjeta') inputFechaExpedicionTarjeta!: ElementRef;
  @ViewChild('inputFechaVencimientoTarjeta') inputFechaVencimientoTarjeta!: ElementRef;
  @ViewChild('inputAseguradoraSoat') inputAseguradoraSoat!: ElementRef;
  @ViewChild("inputfechaexpedicion") inputfechaexpedicion!: ElementRef;
  @ViewChild("inputIdSoat") inputIdSoat!: ElementRef;
  @ViewChild("inputFechaSoat") inputFechaSoat!: ElementRef;
  @ViewChild("inputFechaVencimientoSoat") inputFechaVencimientoSoat!: ElementRef;
  @ViewChild("inputCertificadoCda") inputCertificadoCda!: ElementRef;
  @ViewChild("inputCentroCda") inputCentroCda!: ElementRef;
  @ViewChild("inputFechaExpedicionCda") inputFechaExpedicionCda!: ElementRef;
  @ViewChild("inputFechaVencimientoCda") inputFechaVencimientoCda!: ElementRef;
  @ViewChild("inputIdExtintor") inputIdExtintor!: ElementRef;
  @ViewChild("inputFrecarga") inputFrecarga!: ElementRef;
  @ViewChild("inputVrecarga") inputVrecarga!: ElementRef;
  @ViewChild("inputCentroBim") inputCentroBim!: ElementRef;
  @ViewChild("inputRevisionBim") inputRevisionBim!: ElementRef;
  @ViewChild("inputUltimaRevisionBim") inputUltimaRevisionBim!: ElementRef;
  @ViewChild("inputProximaRevisionBim") inputProximaRevisionBim!: ElementRef;
  @ViewChild("inputAseguradoraCont") inputAseguradoraCont!: ElementRef;
  @ViewChild("inputIntermediariaCont") inputIntermediariaCont!: ElementRef;
  @ViewChild("inputFechaExpedicionCont") inputFechaExpedicionCont!: ElementRef;
  @ViewChild("inputFechaVencimientoCont") inputFechaVencimientoCont!: ElementRef;
  @ViewChild("inputNumeroCont") inputNumeroCont!: ElementRef;
  @ViewChild("inputAseguradoraExt") inputAseguradoraExt!: ElementRef;
  @ViewChild("inputIntermediariaExt") inputIntermediariaExt!: ElementRef;
  @ViewChild("inputFechaExpedicionExt") inputFechaExpedicionExt!: ElementRef;
  @ViewChild("inputFechaVencimientoExt") inputFechaVencimientoExt!: ElementRef;
  @ViewChild("inputNumeroExt") inputNumeroExt!: ElementRef;
  @ViewChild("inputAseguradoraTodo") inputAseguradoraTodo!: ElementRef;
  @ViewChild("inputFechaExpedicionTodo") inputFechaExpedicionTodo!: ElementRef;
  @ViewChild("inputFechaVencimientoTodo") inputFechaVencimientoTodo!: ElementRef;
  @ViewChild("inputNumeroTodo") inputNumeroTodo!: ElementRef;
  @ViewChild("inputNit") inputNit!: ElementRef;
  @ViewChild("inputNombre") inputNombre!: ElementRef;
  @ViewChild("inputCodigo") inputCodigo!: ElementRef;
  @ViewChild("inputDireccion") inputDireccion!: ElementRef;
  @ViewChild("inputCiudad") inputCiudad!: ElementRef;
  @ViewChild("inputCelular") inputCelular!: ElementRef;
  @ViewChild("inputEmail") inputEmail!: ElementRef;

  public Revision = [
    { value: "1", label: "SI" },
    { value: "2", label: "NO" },
  ];
  public revision!: string; // Aquí se almacena el valor seleccionado del <ng-select>


  public servicio!: string; // Aquí se almacena el valor seleccionado del <ng-select>
  public aseguradora!: string; // Aquí se almacena el valor seleccionado del <ng-select>
  username: string | null = null;
  activePanel: string[] = ["static-1"]; // El panel se abre por defecto
  formData: any = {}; // Inicializar vacío para evitar errores
  empresas!: any[];
  todasLasEmpresas!: any;
  marcas!: any;
  tipos!: any;
  propietarios!: any;
  formNuevo!: FormGroup;
  validate: boolean = false;
  guardandoVehiculo = false;
  errores: any = {};
  relaciones: any;
  modelos: any;
  formTarjeta!: FormGroup;
  formSoat!: FormGroup;
  formCda!: FormGroup;
  formExtintor!: FormGroup;
  empresasaseguradora!: any;
  empresascda!: any;
  formBimestral!: FormGroup;
  formContractual!: FormGroup;
  formExtracontractual!: FormGroup;
  formTodoriesgo!: FormGroup;
  combustibles!: any;
  tipoPeriodos: any[] = [];
  editMode!: boolean;
  formEmpresa!: FormGroup;
  empresaselecionada: any;
  formClase!: FormGroup;
  formRodamiento!: FormGroup;
  formRunt!: FormGroup;
  claseselecionada: any;
  tiposervicio: any;
  listaCDA: any[] = [];
  showPassword = false;
  validarTO = false;
  mostrarTarjeta = false;
  mostrarCda = false;
  mostrarBim = false;
  mostrarCon = false;
  mostrarExt = false;
  mostrarTodo = false;
  validarCDA = false;
  validarBIM = false;
  validarRCC = false;
  validarRCE = false;
  validarPTR = false;
  validarRodamiento = true;
  validarLT: boolean = false;
  validarSOAT: boolean = false
  active2: number | string = 1;
  active: number | string = 1;
  modalEmpresaRef!: NgbModalRef;
  modalClaseRef!: NgbModalRef;
  modalRuntRef!: NgbModalRef;
  mostrarFechaConvenio = false;
  empresaAdministrativaNit: string | null = null;
  empresaAdministrativaNombre: string | null = null;
  autoSeleccionEmpresaAdministrativaPendiente = false;
  maxDate!: string;
  minDate!: string;
  estadoDeshabilitado = true;
  municipios: any;
  user$!: typeof this.authService.currentUser; 
  tiposDocumentoRunt = [
    { value: 'CC', label: 'CC - Cedula de ciudadania' },
    { value: 'CE', label: 'CE - Cedula de extranjeria' },
    { value: 'PA', label: 'PA - Pasaporte' },
    { value: 'NIT', label: 'NIT - NIT para empresas' },
  ];
  RevisionExtintor: any;


  // Hacer que el calendario se cierre al hacer clic fuera del componente
  @HostListener('document:click', ['$event'])
  clickout(event: MouseEvent) {
    const calendar = document.querySelector('.ngb-datepicker');
    if (calendar && !calendar.contains(event.target as Node)) {
      // Aquí el calendario se cierra automáticamente
      // Este comportamiento está controlado por autoClose='outside'
    }
  }
  constructor(
    private empresasService: EmpresasService,
    private marcaService: MarcaService,
    private tiposService: TiposService,
    private propietariosService: PropietarioService,
    private vehiclesService: VehiclesService,
    private relacionService: RelacionService,
    private modelosService: ModelosService,
    private combustibleService: CombustibleService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private tiposervicioService: TipoServicioService,
    private tiposerviciodocumentoService: TiposerviciosDocumentosService,
    private cdr: ChangeDetectorRef,
    private dataService: DataService,
    private authService: AuthService,
    private tipoPeriodoService: TipoPeriodoService,
    private administracionService: AdministracionService
  ) {

  }




  ngOnInit() {
    // Cargar el perfil del usuario al inicializar
    this.user$ = this.authService.currentUser;
    this.user$.subscribe(user => {
      //console.log(user?.email);
      this.username = user?.email || null;
    });
    const today = new Date();
    const formattedDate = this.getTodayDate();
    this.minDate = formattedDate;
    this.maxDate = formattedDate;

    //carga los controles
    this.formNuevo = this.createFormNuevo();
    this.formTarjeta = this.createFormTarjeta();
    this.formSoat = this.createFormSoat();
    this.formCda = this.createFormCda();
    this.formExtintor = this.createFormExtintor();
    this.formBimestral = this.createFormBimestral();
    this.formContractual = this.createFormContractual();
    this.formExtracontractual = this.createFormExtracontractual();
    this.formTodoriesgo = this.createFormTodoriesgo();
    this.formEmpresa = this.createFormEmpresa();
    this.formClase = this.createFormClase();
    this.formRodamiento = this.createFormRodamiento();
    this.formRunt = this.createFormRunt();

    this.formNuevo.get('Idpropietario')?.valueChanges.subscribe((value) => {
      this.onPropietarioChange(value);
    });
    
    // Configurar validación delayed para afiliación
    this.setupAfiliacionValidation();
    this.setupRodamientoVencimiento();

    //carga los datos de los selectores  
    this.cargarCiudades();
    this.loadDatosPrincipales();
    this.loadEmpresas();
    this.cargarEmpresaAdministrativa();
    this.suscribirseFecha(this.formSoat, 'fecha_soat', 'vencimiento_soat', { anioCompleto: true }); //SOAT
    this.suscribirseFecha(this.formBimestral, 'ultima_revision', 'proxima_revision', { dias: 60 });  //BIM
   
   
    this.suscribirseFecha(this.formCda, 'fechacda', 'vcda', { anioCompleto: true });//CDA 
    this.suscribirseFecha(this.formExtintor, 'frecarga', 'vrecarga', { anioCompleto: true }); //EXTINTOR
    this.suscribirseFecha(this.formContractual, 'fecha_expedicionRCC', 'fecha_vencimientoRCC', { anioCompleto: true }); //RCC
    this.suscribirseFecha(this.formExtracontractual, 'fecha_expedicionRCE', 'fecha_vencimientoRCE', { anioCompleto: true }); //RCC
    this.suscribirseFecha(this.formTodoriesgo, 'fecha_expedicionTD', 'fecha_vencimientoTD', { anioCompleto: true }); //RCC
  }

  seleccionarModoCreacion(modo: 'manual' | 'runt', runtModal?: TemplateRef<any>) {
    this.modoCreacion = modo;

    if (modo === 'runt' && runtModal) {
      this.formRunt.reset({
        documentType: 'CC',
        documentNumber: '',
        plate: ''
      });

      this.modalRuntRef = this.modalService.open(runtModal, {
        size: 'lg',
        backdrop: 'static'
      });
    }
  }

  consultarDatosRunt(modalRef: NgbModalRef): void {
              // Enfocar el buscador de CDA si se llenó automáticamente
              setTimeout(() => {
                try {
                  if (this.inputCentroCda) {
                    if ('focus' in this.inputCentroCda) {
                      // Si es un NgSelectComponent
                      (this.inputCentroCda as any).focus();
                    } else if (this.inputCentroCda.nativeElement && typeof this.inputCentroCda.nativeElement.focus === 'function') {
                      // Si es un ElementRef
                      this.inputCentroCda.nativeElement.focus();
                    }
                  }
                } catch (e) {}
              }, 300);
    this.validate = true;

    if (this.formRunt.invalid) {
      this.formRunt.markAllAsTouched();
      this.mostrarAlerta('Campos requeridos', 'Complete los datos del formulario RUNT.', 'info');
      return;
    }

    const datosRunt = this.formRunt.value;
    const params = {
      documentType: datosRunt.documentType,
      documentNumber: datosRunt.documentNumber,
      plate: (datosRunt.plate || '').toUpperCase()
    };

    Swal.fire({
      title: 'Consultando RUNT',
      text: 'Espere un momento por favor...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.vehiclesService.getRuntVehicleByPlate(params).subscribe({
      next: (respuesta) => {
        Swal.close();
      //  console.log('Respuesta completa del RUNT:', respuesta, 'tipo:', typeof respuesta);

        // Soporta ambos formatos: respuesta directa o anidada en respuesta.data
        const datosVehiculo = respuesta?.data ?? respuesta;
        const placaRunt =
          datosVehiculo?.plate ||
          datosVehiculo?.informacionGeneral?.noPlaca ||
          params.plate;

        if (datosVehiculo && placaRunt) {
       //   console.log('Datos RUNT obtenidos:', datosVehiculo);
          
          // Buscar el ID del combustible por nombre
          const combustibleRunt = datosVehiculo.informacionGeneral?.tipoCombustible;
          const combustibleEncontrado = this.combustibles?.find(c => 
            c.nombre?.toLowerCase() === combustibleRunt?.toLowerCase()
          );
          
          // Buscar el ID del servicio por descripción
          const servicioRunt = datosVehiculo.informacionGeneral?.tipoServicio;
          const servicioEncontrado = this.tiposervicio?.find(s => 
            s.Descripcion?.toLowerCase() === servicioRunt?.toLowerCase()
          );
          
          // Buscar el ID de la clase de vehículo por nombre
          const claseRunt = datosVehiculo.informacionGeneral?.claseVehiculo;
          const claseEncontrada = this.tipos?.find(c => 
            c.tipos?.toLowerCase() === claseRunt?.toLowerCase()
          );
          
          // Buscar el ID de la marca por nombre
          const marcaRunt = datosVehiculo.informacionGeneral?.marca;
          const marcaEncontrada = this.marcas?.find(m => 
            m.marca?.toLowerCase() === marcaRunt?.toLowerCase()
          );

          // Buscar el propietario por número de documento ingresado en el modal
          const propietarioRunt = datosRunt.documentNumber;
          const propietarioEncontrado = this.propietarios?.find((p: any) =>
            String(p.cedula) === String(propietarioRunt)
          );

          // Filtrar SOAT vigente
          // Filtrar RTM (tecnoMecanica) vigente con tolerancia a distintos formatos del RUNT
          const tecnoMecanicas = Array.isArray(datosVehiculo)
            ? datosVehiculo
            : Array.isArray(datosVehiculo?.tecnoMecanica)
              ? datosVehiculo.tecnoMecanica
              : Array.isArray((respuesta as any)?.tecnoMecanica)
                ? (respuesta as any).tecnoMecanica
                : Array.isArray((respuesta as any)?.data?.tecnoMecanica)
                  ? (respuesta as any).data.tecnoMecanica
                  : [];

          const esRtmVigente = (rtm: any): boolean => {
            const estado = String(rtm?.estado ?? rtm?.vigencia ?? '').toUpperCase();
            const vigente = String(rtm?.vigente ?? '').toUpperCase();
            return (
              rtm?.vigente === true ||
              ['SI', 'S', 'TRUE', '1', 'VIGENTE', 'ACTIVO'].includes(vigente) ||
              estado.includes('VIGENTE') ||
               estado.includes('APROBADA') ||
              estado.includes('ACTIVO')
            );
          };
          console.log('TecnoMecanicas encontradas:', tecnoMecanicas);
          const obtenerPrimerValorRtm = (rtm: any, campos: string[]): string => {
            for (const campo of campos) {
              const valor = rtm?.[campo];
              if (valor !== null && valor !== undefined && String(valor).trim() !== '') {
                return String(valor).trim();
              }
            }
            return '';
          };

          const rtmVigente = tecnoMecanicas.find((t: any) => esRtmVigente(t)) || tecnoMecanicas[0] || null;

          const numeroCertificadoRtm = obtenerPrimerValorRtm(rtmVigente, [
            'nroCertificado',
            'numeroCertificado',
          ]);

          const nombreCdaRtm = obtenerPrimerValorRtm(rtmVigente, [
            'cdaExpide',
           
          ]);

        

          const fechaExpedicionRtm = this.normalizarFechaRunt(
            obtenerPrimerValorRtm(rtmVigente, ['fechaExpedicion', 'fechaRevision', 'fechaRTM'])
          );

          console.log('Fecha expedición RTM encontrada:', fechaExpedicionRtm);

          const fechaVencimientoRtm = this.normalizarFechaRunt(
            obtenerPrimerValorRtm(rtmVigente, ['fechaVencimiento', 'fechaProximaRevision', 'vence'])
          );
          console.log('Fecha vencimiento RTM encontrada:', fechaVencimientoRtm);
                    // Búsqueda de CDA se realizará después de definir normalizarNombre

                    
          let soatRunt = null;
          if (Array.isArray(datosVehiculo.soat)) {
            soatRunt = datosVehiculo.soat.find((s: any) => s.estado?.toUpperCase() === 'VIGENTE') || null;
          }

          let cdaRunt = null;
          if (Array.isArray(tecnoMecanicas)) {
            cdaRunt = tecnoMecanicas.find((s: any) => esRtmVigente(s)) || null;
          }

          const llavesPolizasRunt = Object.keys(datosVehiculo || {}).filter((key) =>
            /poliza|responsabilidad/i.test(key)
          );
          console.log('Llaves de pólizas disponibles en RUNT:', llavesPolizasRunt);

          const normalizarTextoPoliza = (valor: any): string => {
            if (typeof valor !== 'string') {
              return '';
            }

            return valor
              .toLowerCase()
              .normalize('NFD').replace(/\p{Diacritic}/gu, '')
              .replace(/\s+/g, ' ')
              .trim();
          };

          const tieneTextoPoliza = (poliza: any, patron: RegExp): boolean => {
            const valores = [
              poliza?.tipo,
              poliza?.tipoPoliza,
              poliza?.clase,
              poliza?.descripcion,
              poliza?.nombre,
              poliza?.amparo,
              poliza?.tipoResponsabilidad,
            ];

            return valores.some((valor) => typeof valor === 'string' && patron.test(valor));
          };

          const esTipoPoliza = (poliza: any, tipoEsperado: string): boolean => {
            return normalizarTextoPoliza(poliza?.tipoPoliza) === normalizarTextoPoliza(tipoEsperado);
          };

          const coincideTipoPoliza = (poliza: any, tipoEsperado: string, patronRespaldo: RegExp): boolean => {
            const tipoPolizaNormalizado = normalizarTextoPoliza(poliza?.tipoPoliza);

            if (tipoPolizaNormalizado) {
              return tipoPolizaNormalizado === normalizarTextoPoliza(tipoEsperado);
            }

            return tieneTextoPoliza(poliza, patronRespaldo);
          };

          const buscarPolizaVigente = (
            etiqueta: string,
            candidatas: string[],
            filtroExtra?: (poliza: any) => boolean,
          ) => {
            const coleccionEncontrada = candidatas.find((propiedad) => Array.isArray((datosVehiculo as any)[propiedad]));

            if (!coleccionEncontrada) {
             // console.log(`${etiqueta}: no se encontró ninguna colección`, candidatas);
              return null;
            }

            const polizas = (datosVehiculo as any)[coleccionEncontrada];
            const vigente = polizas.find((poliza: any) => {
              const estaVigente = poliza?.estado?.toUpperCase?.() === 'VIGENTE';
              return estaVigente && (!filtroExtra || filtroExtra(poliza));
            }) || null;

         //   console.log(`${etiqueta}: colección usada`, coleccionEncontrada);
         //   console.log(`${etiqueta}: total pólizas`, polizas.length);
          //  console.log(`${etiqueta}: póliza vigente`, vigente);

            return vigente;
          };

          // Filtrar Póliza de Responsabilidad Civil vigente general
          const polizaResponsabilidadCivilVigente = buscarPolizaVigente(
            'RC general',
            ['polizasResponsabilidadCivil', 'responsabilidadCivil', 'polizasRC']
          );

          // Filtrar Póliza de Responsabilidad Civil Contractual vigente
          const polizaResponsabilidadCivilContractualVigente = buscarPolizaVigente(
            'RCC',
            ['polizasResponsabilidadCivil'],
            (poliza: any) =>
              coincideTipoPoliza(poliza, 'Responsabilidad Civil Contractual', /(^|\s)contractual($|\s)/i)
          );

          // Filtrar Póliza de Responsabilidad Civil Extracontractual vigente
          const polizaResponsabilidadCivilExtracontractualVigente = buscarPolizaVigente(
            'RCE',
            ['polizasResponsabilidadCivil'],
            (poliza: any) =>
              coincideTipoPoliza(poliza, 'Responsabilidad Civil Extracontractual', /extracontractual/i)
          );

          // Buscar aseguradora por coincidencia flexible (includes)
          function normalizarNombre(nombre: string): string {
            if (!nombre) return '';
            return nombre
              .toLowerCase()
              .normalize('NFD').replace(/\p{Diacritic}/gu, '')
              .replace(/\./g, '')
              .replace(/,/g, '')
              .replace(/ s a$/g, ' sa')
              .replace(/ s a\.$/g, ' sa')
              .replace(/ s.a.$/g, ' sa')
              .replace(/ s.a/g, ' sa')
              .replace(/ s.a.$/g, ' sa')
              .replace(/ s.a\./g, ' sa')
              .replace(/ s a/g, ' sa')
              .replace(/de seguros/g, 'de seguros')
              .replace(/compania/g, 'compania')
              .replace(/\s+/g, ' ')
              .trim();
          }

          // Buscar CDA por coincidencia flexible (igual que SOAT)
          let cdaEncontrada = null;
          if (rtmVigente && Array.isArray(this.empresascda)) {
            //console.log('=== BÚSQUEDA DE CDA ===');
            //console.log('Objeto RTM vigente completo:', rtmVigente);
            //console.log('Propiedades disponibles en RTM:', Object.keys(rtmVigente));
            
            // Intentar con diferentes propiedades posibles
            const posiblesNombres = [
              nombreCdaRtm,
            ];
            
            let nombreRunt = null;
            for (const nombre of posiblesNombres) {
              if (nombre && typeof nombre === 'string' && nombre.trim()) {
                nombreRunt = nombre;
                console.log('✓ Nombre CDA encontrado en:', nombre);
                break;
              }
            }
            
            if (!nombreRunt) {
              console.log('⚠️ No se encontró el nombre del CDA en ninguna propiedad');
            }
            
            const nombreCdaNorm = normalizarNombre(nombreRunt || '');
            //console.log('Nombre CDA RUNT normalizado:', nombreCdaNorm);
            //console.log('¿Nombre RUNT tiene contenido?:', !!nombreCdaNorm && nombreCdaNorm.trim().length > 0);
            //console.log('Total empresas CDA cargadas:', this.empresascda.length);
            this.empresascda.map((c: any) => ({ 
              nombre: c.nombre, 
              nombreNorm: normalizarNombre(c.nombre || ''),
              nit: c.nit 
            }));
            
            // Solo buscar si hay un nombre válido del RUNT
            if (nombreCdaNorm && nombreCdaNorm.trim()) {
              cdaEncontrada = this.empresascda.find((cda: any) => {
                const nombreCdaNormalizado = normalizarNombre(cda.nombre || '');
                // Evitar coincidencias con nombres vacíos
                if (!nombreCdaNormalizado || !nombreCdaNormalizado.trim()) {
                  return false;
                }
                const match = nombreCdaNormalizado.includes(nombreCdaNorm) || nombreCdaNorm.includes(nombreCdaNormalizado);
              //  console.log(`  Comparando "${nombreCdaNormalizado}" con "${nombreCdaNorm}": ${match}`);
                return match;
              });
            } else {
              console.log('⚠️ Nombre CDA RUNT está vacío o nulo');
            }
           // console.log('✓ CDA encontrada:', cdaEncontrada);
           // console.log('==================');
          } else {
            console.log('⚠️ RTM vigente no existe o empresas CDA no cargadas');
            console.log('  rtmVigente:', rtmVigente);
            console.log('  this.empresascda:', this.empresascda);
          }

          const aseguradoraSoatRunt = soatRunt?.entidadExpideSoat;
          let aseguradoraSoatEncontrada = null;
          if (aseguradoraSoatRunt && Array.isArray(this.empresasaseguradora)) {
            const nombreRuntNorm = normalizarNombre(aseguradoraSoatRunt);
            aseguradoraSoatEncontrada = this.empresasaseguradora.find((empresa: any) =>
              normalizarNombre(empresa.nombre).includes(nombreRuntNorm) || nombreRuntNorm.includes(normalizarNombre(empresa.nombre))
            );
          }

          const obtenerPrimerValorTexto = (objeto: any, campos: string[]): string => {
            for (const campo of campos) {
              const valor = objeto?.[campo];
              if (typeof valor === 'string' && valor.trim()) {
                return valor.trim();
              }
            }

            return '';
          };

          const buscarAseguradoraPorPoliza = (poliza: any) => {
            if (!poliza || !Array.isArray(this.empresasaseguradora)) {
              return null;
            }

            const nombreAseguradoraPoliza = obtenerPrimerValorTexto(poliza, [
             
              'entidadExpide',
             
            ]);

            if (!nombreAseguradoraPoliza) {
              return null;
            }

            const nombreRuntNorm = normalizarNombre(nombreAseguradoraPoliza);
            return this.empresasaseguradora.find((empresa: any) => {
              const nombreEmpresaNorm = normalizarNombre(empresa.nombre || '');
              return (
                !!nombreEmpresaNorm &&
                (nombreEmpresaNorm.includes(nombreRuntNorm) || nombreRuntNorm.includes(nombreEmpresaNorm))
              );
            }) || null;
          };

          const aseguradoraRccEncontrada = buscarAseguradoraPorPoliza(polizaResponsabilidadCivilContractualVigente);
          const aseguradoraRceEncontrada = buscarAseguradoraPorPoliza(polizaResponsabilidadCivilExtracontractualVigente);
          
          
       //   console.log('SOAT:',aseguradoraSoatEncontrada, aseguradoraSoatRunt);
          const fechalictValue = this.normalizarFechaRunt(datosVehiculo.informacionGeneral?.fechaMatricula);

          // Mapear datos RUNT a formNuevo
          this.formNuevo.patchValue({
            placa: placaRunt,
            marca: marcaEncontrada?.id || '',
            modelo: datosVehiculo.informacionGeneral?.modelo || '',
            clase: claseEncontrada?.idTipos || '',
            color: datosVehiculo.informacionGeneral?.color || '',
            motor: datosVehiculo.informacionGeneral?.noMotor || '',
            chasis: datosVehiculo.informacionGeneral?.noChasis || '',
            serie: datosVehiculo.informacionGeneral?.noSerie || '',
            vin: datosVehiculo.vin || '',
            carroceria: datosVehiculo.informacionGeneral?.tipoCarroceria || '',
            cilindraje: datosVehiculo.informacionGeneral?.cilindraje || null,
            combustible: combustibleEncontrado?.id || null,
            capacidad: datosVehiculo.informacionGeneral?.pasajerosSentados || null,
            //titular: datosVehiculo.informacionGeneral?.propietario || '',
            Idpropietario: propietarioEncontrado?.cedula || datosRunt.documentNumber || '',
            observaciones: `Vehículo consultado de RUNT - ${placaRunt}`,
            matricula: datosVehiculo.informacionGeneral?.noLicenciaTransito || '', 
            organismo: datosVehiculo.informacionGeneral?.organismoTransito || '', 
            fechalict: fechalictValue,
            linea: datosVehiculo.informacionGeneral?.linea || '',
            servicio: servicioEncontrado?.idServicio ? String(servicioEncontrado.idServicio) : null,
            
          });

          const fechaInicioTarjeta = this.normalizarFechaRunt(datosVehiculo.tarjetaOperacion?.fechaInicio);
          const fechaFinTarjeta = this.normalizarFechaRunt(datosVehiculo.tarjetaOperacion?.fechaFin);

            this.formTarjeta.patchValue({
            placa: placaRunt,  
            numero_tarjeta: datosVehiculo.tarjetaOperacion?.nroTarjetaOperacion || '',
            fecha_expedicion: fechaInicioTarjeta,
            fecha_vencimiento: fechaFinTarjeta,
          });
            
            //console.log(datosVehiculo.soat);
        
          // Mapear datos RTM vigente al formCda
          console.log('[RUNT][RTM] Valores antes de patch formCda:', {
            placaRunt,
            numeroCertificadoRtm,
            nitCdaEncontrada: cdaEncontrada?.nit,
            nombreCdaRtm,
            fechaExpedicionRtm,
            fechaVencimientoRtm,
            rtmVigente,
          });

          this.formCda.patchValue({
            placa: placaRunt,
            idcda: numeroCertificadoRtm || '',
            centrocda: cdaEncontrada?.nit || '',
            fechacda: fechaExpedicionRtm,
            vcda: fechaVencimientoRtm,
          });

          console.log('[RUNT][RTM] Valores despues de patch formCda:', this.formCda.value);

          this.formBimestral.patchValue({
            placa: placaRunt,
          });

          // Disparar manualmente el (change) de fechalict después de mapear CDA
          // para que la lógica de onFechaLicenciaChange sí quede aplicada.
          const tieneDatosRtmEnCda = !!(
            numeroCertificadoRtm ||
            cdaEncontrada?.nit ||
            fechaExpedicionRtm ||
            fechaVencimientoRtm
          );

          if (fechalictValue && !tieneDatosRtmEnCda) {
            const fechaEvent = { target: { value: fechalictValue } } as unknown as Event;
            this.onFechaLicenciaChange(fechaEvent);
          } else if (fechalictValue && tieneDatosRtmEnCda) {
            console.log('[RUNT][RTM] Se omite onFechaLicenciaChange para no sobrescribir CDA cargado desde RTM');
          }
        
            this.cdr.detectChanges(); // Asegurar que la vista se actualice con los nuevos datos

          // Cerrar modal después de popular el formulario
          this.modalRuntRef?.close();
          
          // Validar documentos requeridos según el servicio cargado
          const servicioValue = this.formNuevo.get('servicio')?.value;
          if (servicioValue) {
            const event = new Event('change');
            Object.defineProperty(event, 'target', { 
              value: { value: servicioValue }, 
              enumerable: true 
            });
            this.ValidarDocumentos(event);
          }
          
          // DATOS PARA EL SOAT
          this.formSoat.patchValue({
            placa: placaRunt,
            id_soat: soatRunt?.noPoliza || '',
            fecha_soat: this.normalizarFechaRunt(soatRunt?.fechaVigencia || soatRunt?.fechaVigencia),
            vencimiento_soat: this.normalizarFechaRunt(soatRunt?.fechaVencimiento),
            aseguradora: aseguradoraSoatEncontrada?.nit || '',
            valor: soatRunt?.valor || 0,
            tarifa: soatRunt?.tipoTarifa || null
          });

          this.formContractual.patchValue({
            placa: placaRunt,
            numeroRCC: polizaResponsabilidadCivilContractualVigente?.numeroPoliza || '',
            aseguradoraRCC: aseguradoraRccEncontrada?.nit || '',
            intermediariaRCC: obtenerPrimerValorTexto(polizaResponsabilidadCivilContractualVigente, [
              'intermediario',
              'intermediaria',
              'corredor',
              'broker',
            ]),
            fecha_expedicionRCC: this.normalizarFechaRunt(polizaResponsabilidadCivilContractualVigente?.fechaExpedicion),
            fecha_vencimientoRCC: this.normalizarFechaRunt(
              polizaResponsabilidadCivilContractualVigente?.fechaFinVigencia ||
              polizaResponsabilidadCivilContractualVigente?.fechaVencimiento
            ),
          });

          this.formExtracontractual.patchValue({
            placa: placaRunt,
            numeroRCE: polizaResponsabilidadCivilExtracontractualVigente?.numeroPoliza || '',
            aseguradoraRCE: aseguradoraRceEncontrada?.nit || '',
            intermediariaRCE: obtenerPrimerValorTexto(polizaResponsabilidadCivilExtracontractualVigente, [
              'intermediario',
              'intermediaria',
              'corredor',
              'broker',
            ]),
            fecha_expedicionRCE: this.normalizarFechaRunt(polizaResponsabilidadCivilExtracontractualVigente?.fechaExpedicion),
            fecha_vencimientoRCE: this.normalizarFechaRunt(
              polizaResponsabilidadCivilExtracontractualVigente?.fechaFinVigencia ||
              polizaResponsabilidadCivilExtracontractualVigente?.fechaVencimiento
            ),
          });

         
         


          this.mostrarAlerta('Consulta exitosa', 'Datos RUNT cargados correctamente.', 'success');
        } else {
          console.log('Respuesta RUNT sin placa:', respuesta);
          this.mostrarAlerta('Información incompleta', 'La respuesta del servidor no contiene placa de vehículo.', 'warning');
        }
      },
      error: (err) => {
        Swal.close();
        console.error('Error consultando RUNT:', err);
        const errorMsg = err?.error?.message || 'No se pudo consultar los datos RUNT. Intente nuevamente.';
        this.mostrarAlerta('Error', errorMsg, 'error');
      }
    });
  }

  private suscribirseFecha(form: FormGroup, campoOrigen: string, campoDestino: string, config: { anioCompleto?: boolean, dias?: number }) {
   
    form.get(campoOrigen)?.valueChanges.subscribe((fechaStr: string) => {
      if (!fechaStr) return;

      const fecha = new Date(fechaStr);
      let nuevaFecha: Date;

      if (config.anioCompleto) {
        nuevaFecha = new Date(fecha);
        nuevaFecha.setFullYear(nuevaFecha.getFullYear() + 1);
        nuevaFecha.setDate(nuevaFecha.getDate() - 1); // Un día antes
      } else if (config.dias) {
        nuevaFecha = new Date(fecha);
        nuevaFecha.setDate(nuevaFecha.getDate() + config.dias);
      } else {
        return;
      }

      const nuevaFechaStr = nuevaFecha.toISOString().substring(0, 10);
      form.get(campoDestino)?.setValue(nuevaFechaStr, { emitEvent: false });
    });
  }

  private loadDatosPrincipales() {
    forkJoin({
      marcas: this.marcaService.getMarcas(),
      tipos: this.tiposService.getTipos(),
      relaciones: this.relacionService.getRelaciones(),
      propietarios: this.propietariosService.getPropietarios(),
      modelos: this.modelosService.getModelos(),
      combustibles: this.combustibleService.getAllCombustibles(),
      tiposervicio: this.tiposervicioService.getTipoServicios(),
      tipoPeriodos: this.tipoPeriodoService.getAllTipoPeriodos().pipe(catchError(() => of([])))
    }).subscribe({
      next: ({
        marcas,
        tipos,
        relaciones,
        propietarios,
        modelos,
        combustibles,
        tiposervicio,
        tipoPeriodos
      }) => {
        this.marcas = marcas;
        this.tipos = tipos;
        this.relaciones = relaciones;
        this.propietarios = propietarios.propietarios; // según tu API
        this.asegurarPropietarioEmpresaAdministrativa();
        this.modelos = modelos;
        this.combustibles = combustibles;
        this.tipoPeriodos = tipoPeriodos || [];

        // Lógica especial para tiposervicio
        if (tiposervicio && tiposervicio.length > 0) {
          this.tiposervicio = tiposervicio.sort((a, b) =>
            a.Descripcion === 'Particular' ? -1 : 1
          );

          const particular = this.tiposervicio.find(
            serv => serv.Descripcion === 'Particular'
          );

          if (particular) {
            this.formNuevo.get('servicio')?.setValue(particular.idServicio);
          }
        }
      },
      error: (err) => {
        console.error('Error al cargar datos del catálogo:', err);
      }
    });
  }

    private loadEmpresas() {
   // console.log('Cargando empresas...');

     this.empresasService.getEmpresasPorTipo('transporte', 1).subscribe({
        next: (data) => {
        //console.log(data);
      
        this.empresas =data;
      
      },
      error: (err) => {
        console.error("Error al obtener aseguradoras:", err);
      }
    });

      this.empresasService.getEmpresasPorTipo('aseguradora', 1).subscribe({
        next: (data) => {
       // console.log(data);
      
        this.empresasaseguradora =data;
      
      },
      error: (err) => {
        console.error("Error al obtener aseguradoras:", err);
      }
    });

         this.empresasService.getEmpresasPorTipo('cda', 1).subscribe({
        next: (data) => {
        //console.log(data);
      
        this.empresascda =data;
      
      },
      error: (err) => {
        console.error("Error al obtener aseguradoras:", err);
      }
    });
  }

  guardarVehiculo() {

    this.validate = true;
    this.guardandoVehiculo = true;
    const datosVehiculo = { ...this.formNuevo.value };
    datosVehiculo.servicio = datosVehiculo.servicio != null ? String(datosVehiculo.servicio) : null;

    const placaVehiculo = String(datosVehiculo.placa || '').trim().toUpperCase();

    const datosTarjeta = { ...this.formTarjeta.value, placa: placaVehiculo };
    const datosSoat = { ...this.formSoat.value, placa: placaVehiculo };
    // Si id_soat o valor están vacíos o null, ponerlos en 0
    if (!datosSoat.id_soat || datosSoat.id_soat === '') {
      datosSoat.id_soat = 0;
    }
    if (datosSoat.valor === '' || datosSoat.valor == null) {
      datosSoat.valor = 0;
    }
    const datosCda = { ...this.formCda.value, placa: placaVehiculo };
    const datosExtintor = { ...this.formExtintor.value, placa: placaVehiculo };
    
    const datosBimestral = { ...this.formBimestral.value, placa: placaVehiculo };
   // console.log('Datos Bimestral al guardar:', datosBimestral);
    const datosContractual = { ...this.formContractual.value, placa: placaVehiculo };
    const datosExtracontractual = { ...this.formExtracontractual.value, placa: placaVehiculo };
    const datosTodoriesgo = { ...this.formTodoriesgo.value, placa: placaVehiculo };

    //Tarjeta Operación
    const rawServicio = this.formNuevo.get('servicio')!.value;
    const servicioNum = Number(rawServicio);
    const numeroCtrl = this.formTarjeta.get('numero_tarjeta')!;
    const numeroVal = numeroCtrl.value;

    const rawServicio2 = this.formNuevo.get('servicio')!.value;
    const servicioNum2 = Number(rawServicio2);
    const numeroCtrl2 = this.formTarjeta.get('fecha_expedicion')!;
    const numeroVal2 = numeroCtrl2.value;

    const rawServicio3 = this.formNuevo.get('servicio')!.value;
    const servicioNum3 = Number(rawServicio3);
    const numeroCtrl3 = this.formTarjeta.get('fecha_vencimiento')!;
    const numeroVal3 = numeroCtrl3.value;

    //CDA
    const CdaServicio = this.formNuevo.get('servicio')!.value;
    const CdaServicioNum = Number(CdaServicio);
    const numeroCdaCtrl = this.formCda.get('idcda')!;
    const numeroCdaVal = numeroCdaCtrl.value;

    const CdaServicio2 = this.formNuevo.get('servicio')!.value;
    const CdaServicioNum2 = Number(CdaServicio2);
    const numeroCdaCtrl2 = this.formCda.get('centrocda')!;
    const numeroCdaVal2 = numeroCdaCtrl2.value;

    const CdaServicio3 = this.formNuevo.get('servicio')!.value;
    const CdaServicioNum3 = Number(CdaServicio3);
    const numeroCdaCtrl3 = this.formCda.get('fechacda')!;
    const numeroCdaVal3 = numeroCdaCtrl3.value;

    const CdaServicio4 = this.formNuevo.get('servicio')!.value;
    const CdaServicioNum4 = Number(CdaServicio4);
    const numeroCdaCtrl4 = this.formCda.get('vcda')!;
    const numeroCdaVal4 = numeroCdaCtrl4.value;

    //BIMESTRAL
    const BimServicio = this.formNuevo.get('servicio')!.value;
    const BimServicioNum = Number(BimServicio);
    const numeroBimCtrl = this.formBimestral.get('centro_diagnostico')!;
    const numeroBimVal = numeroBimCtrl.value;

    const BimServicio2 = this.formNuevo.get('servicio')!.value;
    const BimServicioNum2 = Number(BimServicio2);
    const numeroBimCtrl2 = this.formBimestral.get('revision_aprobada')!;
    const numeroBimVal2 = numeroBimCtrl2.value;

    const BimServicio3 = this.formNuevo.get('servicio')!.value;
    const BimServicioNum3 = Number(BimServicio3);
    const numeroBimCtrl3 = this.formBimestral.get('ultima_revision')!;
    const numeroBimVal3 = numeroBimCtrl3.value;

    const BimServicio4 = this.formNuevo.get('servicio')!.value;
    const BimServicioNum4 = Number(BimServicio4);
    const numeroBimCtrl4 = this.formBimestral.get('proxima_revision')!;
    const numeroBimVal4 = numeroBimCtrl4.value;

    //Contractual


    //Extracontractual


    //Todo Riesgo


    //Rodamiento
    const datosRodamiento = {
      ...this.formRodamiento.value,
      tipo_rodamiento: this.formNuevo.get('tipo_rodamiento')?.value
    };

    //Datos basicos Requeridos
    if (!rawServicio) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-1', this.inputServicio, 'servicio', 'Seleccione un Tipo de Servicio');
      this.guardandoVehiculo = false;
      return;
    }

    if (!this.formNuevo.get('placa')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-1', this.inputPlaca, 'placa', 'Ingrese la placa del vehículo');
       this.guardandoVehiculo = false; 
      return;
    }

    if (!this.formNuevo.get('interno')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-1', this.inputInterno, 'interno', 'Ingrese un número interno para el vehículo');
      return;
    }

    if (!this.formNuevo.get('nitEmpresa')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-1', this.inputEmpresa, 'nitEmpresa', 'Seleccione una empresa');
      return;
    }

    if (!this.formNuevo.get('clase')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-1', this.inputClase, 'clase', 'Seleccione una clase de vehículo');
      return;
    }

    if (!this.formNuevo.get('marca')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-1', this.inputMarca, 'marca', 'Seleccione la marca de vehículo');
      return;
    }

    if (!this.formNuevo.get('modelo')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-1', this.inputModelo, 'modelo', 'Seleccione un modelo del vehículo');
      return;
    }

    if (!this.formNuevo.get('relacion')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-1', this.inputRelacion, 'relacion', 'Seleccione una relación del vehículo');
      return;
    }

    if (!this.formNuevo.get('password')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-1', this.inputPassword, 'password', 'Ingrese una contraseña para la app de Alistamientos');
      return;
    }



    //Tarjeta Operación requeridos
    if (this.validarTO && (servicioNum === 1 || servicioNum === 3 || servicioNum === 4) && (numeroVal == null || numeroVal < 1)) {
      numeroCtrl.markAsTouched();
      numeroCtrl.setErrors({ required: true });
      this.errores.numero_tarjeta = 'Por favor, ingrese el número de la tarjeta.';
      if (!this.accordion.isExpanded('static-3')) {
        this.accordion.toggle('static-3');
      }

      setTimeout(() => {
        this.inputNumeroTarjeta.nativeElement.focus();
        Swal.fire('Campo requerido', 'Ingrese el número de la tarjeta de operación', 'info');
      });

      this.guardandoVehiculo = false;
      return;
    }

    if (this.validarTO && (servicioNum2 === 1 || servicioNum2 === 3 || servicioNum2 === 4) && (numeroVal2 == null || numeroVal2 < 1)) {
      numeroCtrl2.markAsTouched();
      numeroCtrl2.setErrors({ required: true });


      if (!this.accordion.isExpanded('static-3')) {
        this.accordion.toggle('static-3');
      }

      setTimeout(() => {
        this.inputFechaExpedicionTarjeta.nativeElement.focus();
        Swal.fire('Campo requerido', 'Ingrese la fecha de expedición', 'info');
      });

      this.guardandoVehiculo = false;
      return;
    }

    if (this.validarTO && (servicioNum3 === 1 || servicioNum3 === 3 || servicioNum3 === 4) && (numeroVal3 == null || numeroVal3 < 1)) {
      numeroCtrl3.markAsTouched();
      numeroCtrl3.setErrors({ required: true });

      if (!this.accordion.isExpanded('static-3')) {
        this.accordion.toggle('static-3');
      }

      setTimeout(() => {
        this.inputFechaVencimientoTarjeta.nativeElement.focus();
        Swal.fire('Campo requerido', 'Ingrese la fecha de vencimiento', 'info');
      });

      this.guardandoVehiculo = false;
      return;
    }

    //Soat requeridos
    if (!this.formSoat.get('aseguradora')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-4', this.inputAseguradoraSoat, 'aseguradora', 'Seleccione una aseguradora');
      return;
    }

    if (!this.formSoat.get('id_soat')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-4', this.inputIdSoat, 'id_soat', 'Ingrese un número');
      return;
    }

    if (!this.formSoat.get('fecha_soat')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-4', this.inputFechaSoat, 'fecha_soat', 'Ingrese una fecha de expedición');
      return;
    }

    if (!this.formSoat.get('vencimiento_soat')!.value) {
      this.guardandoVehiculo = false;
      this.scrollToField('static-4', this.inputFechaVencimientoSoat, 'vencimiento_soat', 'Ingrese una fecha de vencimiento');
      return;
    }

    //Cda requeridos
    if (this.validarCDA && (CdaServicioNum === 1 || CdaServicioNum === 2 || CdaServicioNum === 4 || CdaServicioNum === 5) && (numeroCdaVal == null || numeroCdaVal < 1)) {
      numeroCdaCtrl.markAsTouched();
      numeroCdaCtrl.setErrors({ required: true });

      if (!this.accordion.isExpanded('static-5')) {
        this.accordion.toggle('static-5');
      }

      setTimeout(() => {
        this.inputCertificadoCda.nativeElement.focus();
        Swal.fire('Campo requerido', 'Ingrese el número de certificado', 'info');
      });

      this.guardandoVehiculo = false;
      return;
    }

    if (this.validarCDA && (CdaServicioNum2 === 1 || CdaServicioNum2 === 2 || CdaServicioNum2 === 4 || CdaServicioNum2 === 5) && (numeroCdaVal2 == null || numeroCdaVal2 < 1)) {
      numeroCdaCtrl2.markAsTouched();
      numeroCdaCtrl2.setErrors({ required: true });

      if (!this.accordion.isExpanded('static-5')) {
        this.accordion.toggle('static-5');
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          if (this.inputCentroCda?.nativeElement?.focus) {
            this.inputCentroCda.nativeElement.focus();
          }
        });
        Swal.fire('Campo requerido', 'Ingrese el centro de cda', 'info');
      });

      this.guardandoVehiculo = false;
      return;
    }

    if (this.validarCDA && (CdaServicioNum3 === 1 || CdaServicioNum3 === 2 || CdaServicioNum3 === 4 || CdaServicioNum3 === 5) && (numeroCdaVal3 == null || numeroCdaVal3 < 1)) {
      numeroCdaCtrl3.markAsTouched();
      numeroCdaCtrl3.setErrors({ required: true });

      if (!this.accordion.isExpanded('static-5')) {
        this.accordion.toggle('static-5');
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          if (this.inputFechaExpedicionCda?.nativeElement?.focus) {
            this.inputFechaExpedicionCda.nativeElement.focus();
          }
        });
        Swal.fire('Campo requerido', 'Ingrese una fecha de expedición', 'info');
      });

      this.guardandoVehiculo = false;
      return;
    }

    if (this.validarCDA && (CdaServicioNum4 === 1 || CdaServicioNum4 === 2 || CdaServicioNum4 === 4 || CdaServicioNum4 === 5) && (numeroCdaVal4 == null || numeroCdaVal4 < 1)) {
      numeroCdaCtrl4.markAsTouched();
      numeroCdaCtrl4.setErrors({ required: true });

      if (!this.accordion.isExpanded('static-5')) {
        this.accordion.toggle('static-5');
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          if (this.inputFechaVencimientoCda?.nativeElement?.focus) {
            this.inputFechaVencimientoCda.nativeElement.focus();
          }
        });
        Swal.fire('Campo requerido', 'Ingrese una fecha de vencimiento', 'info');
      });
      this.guardandoVehiculo = false;
      return;
    }

if (this.validarCDA) {

 const idsMotos = [12, 19, 20];

let clasesSeleccionadas = this.formNuevo.get('clase')?.value;

if (!Array.isArray(clasesSeleccionadas)) {
  clasesSeleccionadas = clasesSeleccionadas != null
    ? [Number(clasesSeleccionadas)]
    : [];
}

const esMoto = clasesSeleccionadas.some((id: number) =>
  idsMotos.includes(Number(id))
);

  this.formExtintor.markAllAsTouched();

  if (!esMoto && this.formExtintor.invalid) {

    

    this.active = 2;

    setTimeout(() => {
      if (!this.accordion.isExpanded('static-5')) {
        this.accordion.expand('static-5'); // mejor que toggle()
      }

      requestAnimationFrame(() => {
        const campoInvalido =
          this.formExtintor.get('idextintor')?.invalid ? this.inputIdExtintor :
            this.formExtintor.get('frecarga')?.invalid ? this.inputFrecarga :
              this.formExtintor.get('vrecarga')?.invalid ? this.inputVrecarga :
                null;

        campoInvalido?.nativeElement?.focus();
      });

      Swal.fire(
        'Campo requerido',
        'Complete todos los campos del extintor',
        'info'
      );

    }, 100);
    this.guardandoVehiculo = false;
    return;
  }
}

    //Bimestrales requeridos
    if (this.validarBIM && (BimServicioNum === 1) && (numeroBimVal == null || numeroBimVal < 1)) {
      numeroBimCtrl.markAsTouched();
      numeroBimCtrl.setErrors({ required: true });

      if (!this.accordion.isExpanded('static-6')) {
        this.accordion.toggle('static-6');
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          if (this.inputCentroBim?.nativeElement?.focus) {
            this.inputCentroBim.nativeElement.focus();
          }
        });
        Swal.fire('Campo requerido', 'Ingrese el centro de diagnóstico', 'info');
      });
      this.guardandoVehiculo = false;
      return;
    }

    if (this.validarBIM && (BimServicioNum2 === 1) && (numeroBimVal2 == null || numeroBimVal2 < 1)) {
      numeroBimCtrl2.markAsTouched();
      numeroBimCtrl2.setErrors({ required: true });

      if (!this.accordion.isExpanded('static-6')) {
        this.accordion.toggle('static-6');
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          if (this.inputRevisionBim?.nativeElement?.focus) {
            this.inputRevisionBim.nativeElement.focus();
          }
        });
        Swal.fire('Campo requerido', 'Seleccione la revisión', 'info');
      });

      this.guardandoVehiculo = false;
      return;
    }

    if (this.validarBIM && (BimServicioNum3 === 1) && (numeroBimVal3 == null || numeroBimVal3 < 1)) {
      numeroBimCtrl3.markAsTouched();
      numeroBimCtrl3.setErrors({ required: true });

      if (!this.accordion.isExpanded('static-6')) {
        this.accordion.toggle('static-6');
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          if (this.inputUltimaRevisionBim?.nativeElement?.focus) {
            this.inputUltimaRevisionBim.nativeElement.focus();
          }
        });
        Swal.fire('Campo requerido', 'Ingrese la fecha de la última revisión', 'info');
      });

      this.guardandoVehiculo = false;
      return;
    }

    if (this.validarBIM && (BimServicioNum4 === 1) && (numeroBimVal4 == null || numeroBimVal4 < 1)) {
      numeroBimCtrl4.markAsTouched();
      numeroBimCtrl4.setErrors({ required: true });

      if (!this.accordion.isExpanded('static-6')) {
        this.accordion.toggle('static-6');
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          if (this.inputProximaRevisionBim?.nativeElement?.focus) {
            this.inputProximaRevisionBim.nativeElement.focus();
          }
        });
        Swal.fire('Campo requerido', 'Ingrese la fecha de la próxima revisión', 'info');
      });

      this.guardandoVehiculo = false;
      return;
    }


    const camposContractual = [
      { ctrlName: 'aseguradoraRCC', viewRef: this.inputAseguradoraCont, mensaje: 'Seleccione una aseguradora' },
      { ctrlName: 'fecha_expedicionRCC', viewRef: this.inputFechaExpedicionCont, mensaje: 'Ingrese una fecha de expedición' },
      { ctrlName: 'fecha_vencimientoRCC', viewRef: this.inputFechaVencimientoCont, mensaje: 'Ingrese una fecha de vencimiento' },
      { ctrlName: 'numeroRCC', viewRef: this.inputNumeroCont, mensaje: 'Ingrese un número de Póliza Contractual' },
    ];

    //Contractual requeridos
    for (const campo of camposContractual) {
      const control = this.formContractual.get(campo.ctrlName)!;
      const valor = control.value;

      if (this.validarRCC && servicioNum === 1 && (valor == null || valor < 1)) {
        control.markAsTouched();
        control.setErrors({ required: true });

        this.active2 = 1;

        if (!this.accordion.isExpanded('static-7')) {
          this.accordion.toggle('static-7');
        }

        setTimeout(() => {
          requestAnimationFrame(() => {
            campo.viewRef?.nativeElement?.focus?.();
          });
          Swal.fire('Campo requerido', campo.mensaje, 'info');
        });
        this.guardandoVehiculo = false;
        return;
      }
    }


    const camposExt = [
      { ctrlName: 'aseguradoraRCE', viewRef: this.inputAseguradoraExt, mensaje: 'Seleccione una aseguradora' },
      { ctrlName: 'fecha_expedicionRCE', viewRef: this.inputFechaExpedicionExt, mensaje: 'Ingrese una fecha de expedición' },
      { ctrlName: 'fecha_vencimientoRCE', viewRef: this.inputFechaVencimientoExt, mensaje: 'Ingrese una fecha de vencimiento' },
      { ctrlName: 'numeroRCE', viewRef: this.inputNumeroExt, mensaje: 'Ingrese un número de Póliza extracontractual' },
    ];

    //Extracontractual requerido 
    for (const campo of camposExt) {
      const control = this.formExtracontractual.get(campo.ctrlName)!;
      const valor = control.value;

      if (this.validarRCE && servicioNum === 1 && (valor == null || valor < 1)) {
        control.markAsTouched();
        control.setErrors({ required: true });

        this.active2 = 2;

        if (!this.accordion.isExpanded('static-7')) {
          this.accordion.toggle('static-7');
        }

        setTimeout(() => {
          requestAnimationFrame(() => {
            campo.viewRef?.nativeElement?.focus?.();
          });
          Swal.fire('Campo requerido', campo.mensaje, 'info');
        });

        this.guardandoVehiculo = false;
        return;
      }
    }

    if (
      this.formNuevo.invalid ||
      (this.mostrarTarjeta && this.formTarjeta.invalid)
    ) {
      this.guardandoVehiculo = false;
      Swal.fire({
        title: 'Error',
        text: 'Por favor, complete todos los campos requeridos.',
        icon: 'error',
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    datosVehiculo.estado = 1;
    
    datosVehiculo.usuario_creacion = this.username || 'Desconocido';
    
   // console.log('Datos a datosVehiculo:',datosVehiculo);
   // console.log('Datos a datosTarjeta:',datosTarjeta);
   // console.log('Datos a datosBimestral:',datosBimestral);
   // console.log('Datos a datosContractual:',datosContractual);
   // console.log('Datos a datosExtracontractual:',datosExtracontractual);
  
  

    //return;
    this.vehiclesService.createVehicle(
      datosVehiculo,
      datosTarjeta,
      datosSoat,
      datosCda,
      datosExtintor,
      datosBimestral,
      datosContractual,
      datosExtracontractual,
      datosTodoriesgo,
      
    ).subscribe(
      response => {
        this.guardandoVehiculo = false;
        Swal.fire({
          title: '¡Registro exitoso!',
          text: 'El vehículo ha sido registrado correctamente.',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        });
        this.resetForm();
      },
      error => {
        this.guardandoVehiculo = false;
        let mensaje = 'No se pudo registrar el vehículo. Intente nuevamente.';
        if (error?.error?.message) mensaje = error.error.message;
        else if (typeof error?.error === 'string') mensaje = error.error;
        if (mensaje.includes('placa')) {
          this.formNuevo.get('placa')!.setErrors({ placaDuplicada: true });
        }
        Swal.fire('Error', mensaje, 'error');
      }
    );
  }
  // Función para reiniciar el formulario de vehículo
   resetForm() {
    this.formNuevo.reset();
    this.formTarjeta.reset();
    this.formSoat.reset();
    this.formCda.reset();
    this.formExtintor.reset();
    this.formBimestral.reset();
    this.formContractual.reset();
    this.formExtracontractual.reset();
    this.formTodoriesgo.reset();
    this.formEmpresa.reset();
    this.formRodamiento.reset();
    this.validate = false;
    this.errores = {};
  } 

  onSubmit() {
    if (this.formNuevo.valid) {
      this.guardarVehiculo();
    } else {
      console.log('Formulario inválido');
    }
  }

  onDateSelect(event: any): void {
    // Convierte la fecha seleccionada a formato 'yyyy-MM-dd'
    const fechaFormateada = `${event.year}-${String(event.month).padStart(2, '0')}-${String(event.day).padStart(2, '0')}`;
    this.formNuevo.get('registro')?.setValue(fechaFormateada);
  }

  togglePanel(panelId: string) {
    this.activePanel = this.activePanel.includes(panelId) ? [] : [panelId];
  }

  openModalEmpresa(content: any, empresa?: any): void {
    if (empresa) {
      this.editMode = true;
      this.empresaselecionada = empresa;
      this.formEmpresa.patchValue(empresa); // Carga datos en el formulario para editar
    } else {
      this.editMode = false;
      this.formEmpresa.reset(); // Limpia el formulario para un nuevo registro
    }

    const modalRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });

    this.modalEmpresaRef = modalRef;
  }

  guardarEmpresa(modalRef: NgbModalRef): void {
    this.validate = true;
    const datos = this.formEmpresa.value;
    const email = datos.email;

     if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return this.mostrarAlerta("Email inválido", "Correo no válido. Ej: usuario@dominio.com", "info");
    }
  

    if (!this.formEmpresa.get('nit')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un número de documento", "info");
      this.inputNit?.nativeElement.focus();
      return;
    }

    const digitoValue = this.formEmpresa.get('digito')?.value;
    if (digitoValue === null || digitoValue === undefined || digitoValue === '') {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un digito de verificación", "info");
      this.inputCodigo?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('nombre')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un nombre", "info");
      this.inputNombre?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('direccion')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa una dirección", "info");
      this.inputDireccion?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('ciudad')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa una ciudad", "info");
      this.inputCiudad?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('celular')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un número de celular", "info");
      this.inputCelular?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('email')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un correo electronico", "info");
      this.inputEmail?.nativeElement.focus();
      return;
    }

    if (!this.validarTipoEmpresaSeleccionado()) {
      return;
    }

    const tipoKeys = [
      "eps", "arl", "afp", "ces", "ccf", "bancos", "transporte", "colegio",
      "cda", "taller", "eds", "contratista", "proveedor", "aseguradora",
      "almacen", "serviteca"
    ];
    const datosEmpresas = { ...datos };

    tipoKeys.forEach((k) => datosEmpresas[k] = datosEmpresas[k] ? 1 : 0);
    if (!tipoKeys.some((k) => datosEmpresas[k] === 1)) {
      return this.mostrarAlerta("Tipo requerido", "Selecciona al menos un tipo de empresa.", "info");
    }

    datos.estado = 1;

    this.empresasService.createEmpresa(datos).subscribe({
      next: (empresaCreada) => {
        modalRef.close();

        this.empresasService.getEmpresasCDA().subscribe({
          next: (cdaEmpresas) => {
            this.listaCDA = cdaEmpresas;
            this.loadEmpresas();
            this.formNuevo.get('nitEmpresa')?.setValue(empresaCreada.nit);
          },
          error: (err) => console.error('Error al cargar empresas actualizadas:', err)
        });

        this.mostrarAlerta("Éxito", "Empresa registrada correctamente", "success");
      },
      error: () => this.mostrarAlerta("Error", "No se pudo registrar la empresa", "error")
    });
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({ title: titulo, text: mensaje, icon: icono, confirmButtonColor: "#3085d6" });
  }

  openModalClase(content: any, clase?: any): void {
    if (clase) {
      this.editMode = true;
      this.claseselecionada = clase;
      this.formClase.patchValue(clase); // Carga datos en el formulario para editar
    } else {
      this.editMode = false;
      this.formClase.reset(); // Limpia el formulario para un nuevo registro
    }

    this.modalService.open(content, {
      size: 'xl',
      backdrop: 'static',
      windowClass: 'custom-modal-full-width'
    });
  }

  guardarClase(): void {
    if (this.formClase.invalid) {
      Swal.fire({
        icon: 'error',
        title: 'Formulario inválido',
        text: 'Por favor, completa todos los campos correctamente.'
      });
      return;
    }

    const usuarioActual = this.authService.getCurrentUserValue();
    const fechaHoy = this.getTodayDate();
    const datosClase = {
      ...this.formClase.value,
      estado: 1,
      fecha: fechaHoy,
      modificado: fechaHoy,
      usuario_creacion: usuarioActual?.username ?? usuarioActual?.email ?? ''
    };
    this.tiposService.createTipo(datosClase).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: 'Guardado exitoso',
          text: ' creada correctamente.'
        });
        this.formClase.reset();
        this.modalService.dismissAll(); // Cierra el modal
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar',
          text: err.error?.message || 'Ocurrió un error inesperado.'
        });
      }
    });
  }

  cerrarModal(): void {
    // Mover el foco a un elemento visible antes de cerrar el modal
    const elementoDestino = document.getElementById('elementoDestino'); // Por ejemplo, el botón que abre el modal
    if (elementoDestino) {
      elementoDestino.focus();
    }
    this.modalService.dismissAll();
  }

  ValidarDocumentos(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    const id = Number(selectedValue);

    this.tiposerviciodocumentoService
      .getTiposervicioDocumentoById(id)
      .subscribe(
        (servicio) => {
          if (Array.isArray(servicio)) {
            this.validarTO = servicio.some(
              (item) => item.documento?.sigla === "TO"
            );
            this.validarBIM = servicio.some(
              (item) => item.documento?.sigla === "BIM"
            );
            this.validarLT = servicio.some(
              (item) => item.documento?.sigla === "LT"
            );
            this.validarRCC = servicio.some(
              (item) => item.documento?.sigla === "RCC"
            );
            this.validarRCE = servicio.some(
              (item) => item.documento?.sigla === "RCE"
            );
            this.validarSOAT = servicio.some(
              (item) => item.documento?.sigla === "SOAT"
            );
            this.validarCDA = servicio.some(
              (item) => item.documento?.sigla === "CDA"
            );
            this.validarPTR = servicio.some(
              (item) => item.documento?.sigla === "PTR"
            );

            // Aquí se controla si se muestra y valida el campo número de tarjeta
            const numeroTarjetaCtrl = this.formTarjeta.get("numero_tarjeta");
            this.mostrarTarjeta = this.validarTO;

            if (this.mostrarTarjeta) {
              numeroTarjetaCtrl?.setValidators([Validators.required]);
            } else {
              numeroTarjetaCtrl?.clearValidators();
              numeroTarjetaCtrl?.setValue("");
              numeroTarjetaCtrl?.markAsUntouched();
            }
            numeroTarjetaCtrl?.updateValueAndValidity();
          } else {
            console.error("Error: servicio no es un array", servicio);
            this.validarTO = false;
            this.mostrarTarjeta = false;
          }
        },
        (error) => {
          console.error("Error obteniendo el servicio:", error);
          this.validarTO = false;
          this.mostrarTarjeta = false;
        }
      );
  }

  onRelacionChange(item: any): void {
    const relacionSeleccionada = this.obtenerRelacionSeleccionada(item);
    const textoRelacion = String(relacionSeleccionada?.relacion || '')
      .toLowerCase()
      .normalize('NFD').replace(/\p{Diacritic}/gu, '')
      .trim();

    this.mostrarFechaConvenio =
      Number(relacionSeleccionada?.id) === 8 || textoRelacion === 'convenios';

    this.aplicarEmpresaAdministrativaPorRelacion(relacionSeleccionada);

    const convenioControl = this.formNuevo.get('convenio');

    if (this.mostrarFechaConvenio) {
      convenioControl?.setValidators([Validators.required]);
    } else {
      convenioControl?.clearValidators();
      convenioControl?.setValue(null);
    }
    convenioControl?.updateValueAndValidity();
  }

  private obtenerRelacionSeleccionada(item: any): any {
    if (item && typeof item === 'object') {
      return item;
    }

    const idRelacion = Number(item);
    if (Number.isNaN(idRelacion)) {
      return null;
    }

    return this.relaciones?.find((r: any) => Number(r.id) === idRelacion) || null;
  }

  private cargarEmpresaAdministrativa(): void {
    this.administracionService.obtenerTodas().subscribe({
      next: (data: any[]) => {
        this.empresaAdministrativaNit = data?.[0]?.nit ? String(data[0].nit) : null;
        this.empresaAdministrativaNombre = this.extraerNombreEmpresaAdministrativa(data?.[0]);
        this.asegurarPropietarioEmpresaAdministrativa();
        if (this.autoSeleccionEmpresaAdministrativaPendiente && this.empresaAdministrativaNit) {
          this.formNuevo.get('nitEmpresa')?.setValue(this.empresaAdministrativaNit);
          this.formNuevo.get('Idpropietario')?.setValue(this.obtenerValorPropietarioAdministrativo());
          this.autoSeleccionEmpresaAdministrativaPendiente = false;
        }
      },
      error: (err) => {
        console.error('Error al cargar empresa administrativa:', err);
        this.empresaAdministrativaNit = null;
        this.autoSeleccionEmpresaAdministrativaPendiente = false;
      }
    });
  }

  private aplicarEmpresaAdministrativaPorRelacion(relacionSeleccionada: any): void {
    const relacion = String(relacionSeleccionada?.relacion || '')
      .toLowerCase()
      .normalize('NFD').replace(/\p{Diacritic}/gu, '')
      .trim();

    const esAfiliado = relacion.includes('afiliado');
    const esPropio = relacion.includes('propio');
    const esAfiliadoOPropio = esAfiliado || esPropio;

    if (!esAfiliadoOPropio) {
      const propietarioActual = this.formNuevo.get('Idpropietario')?.value;
      this.autoSeleccionEmpresaAdministrativaPendiente = false;
      this.formNuevo.get('nitEmpresa')?.setValue(null);
      if (this.empresaAdministrativaNit && String(propietarioActual) === String(this.empresaAdministrativaNit)) {
        this.formNuevo.get('Idpropietario')?.setValue(null);
      }
      return;
    }

    if (!this.empresaAdministrativaNit) {
      this.autoSeleccionEmpresaAdministrativaPendiente = true;
      this.cargarEmpresaAdministrativa();
      return;
    }

    this.asegurarPropietarioEmpresaAdministrativa();
    this.formNuevo.get('nitEmpresa')?.setValue(this.empresaAdministrativaNit);

    // Si la relación es Propio, se asigna automáticamente la empresa administrativa como propietario.
    if (esPropio) {
      this.formNuevo.get('Idpropietario')?.setValue(this.obtenerValorPropietarioAdministrativo());
      return;
    }

    // Si la relación es Afiliado, no se fuerza el propietario.
    const propietarioActual = this.formNuevo.get('Idpropietario')?.value;
    if (this.empresaAdministrativaNit && String(propietarioActual) === String(this.empresaAdministrativaNit)) {
      this.formNuevo.get('Idpropietario')?.setValue(null);
    }
  }

  private extraerNombreEmpresaAdministrativa(administracion: any): string {
    const candidatos = [
   
      administracion?.empresa,
    ];

    const encontrado = candidatos.find((valor) => typeof valor === 'string' && valor.trim());
    return encontrado ? String(encontrado).trim() : 'EMPRESA ADMINISTRATIVA';
  }

  private obtenerValorPropietarioAdministrativo(): any {
    const propietario = this.propietarios?.find((p: any) =>
      String(p?.cedula) === String(this.empresaAdministrativaNit)
    );

    return propietario?.cedula ?? this.empresaAdministrativaNit;
  }

  private asegurarPropietarioEmpresaAdministrativa(): void {
    if (!Array.isArray(this.propietarios) || !this.empresaAdministrativaNit) {
      return;
    }

    const existe = this.propietarios.some((p: any) =>
      String(p?.cedula) === String(this.empresaAdministrativaNit)
    );

    if (existe) {
      return;
    }

    this.propietarios = [
      ...this.propietarios,
      {
        cedula: this.empresaAdministrativaNit,
        primernombre: this.empresaAdministrativaNombre || 'EMPRESA',
        segundonombre: '',
        papellidos: '',
        seapellidos: '',
      },
    ];
  }

  private createFormNuevo(): FormGroup {
    return this.fb.group({
      servicio: ['', Validators.required],
      placa: [''],
      interno: [''],
      afiliacion: [this.getTodayDate()], // ✅ Fecha actual - validación con delay
      registro: [null],       // ✅ Null por defecto
      nitEmpresa: [''],
      estado: ['1'],
      clase: [''],
      marca: [''],
      modelo: [''],
      relacion: [''],
      Idpropietario: [''],
      sucursal: [''],
      convenio: [null],
      password: [''],
      matricula: [null],      // ✅ Null por defecto
      organismo: [''],
      fechalict: [null, [this.validarFechaLicencia.bind(this)]],      // Validación de fecha
      linea: [''],
      cilindraje: [null],     // ✅ Null por defecto
      motor: [''],
      titular: [''],
      capacidad: [0],
      color: [''],
      serie: [''],
      chasis: [''],
      carroceria: [''],
      combustible: [null],
      observaciones: [''],
      kilometraje: [0],
      tipo_rodamiento: [''],
      vin: [''],
    });
  }

  private createFormTarjeta(): FormGroup {
    return this.fb.group({
      placa: [''],
      numero_tarjeta: ['', [Validators.pattern('^[0-9]+$')]],
      fecha_expedicion: [''],
      fecha_vencimiento: [''],
      usuario_creacion: ['admin'],
    });
  }

  private createFormSoat(): FormGroup {
    return this.fb.group({
      placa: [''],
      id_soat: [''],
      fecha_soat: [''],
      vencimiento_soat: [''],
      aseguradora: [''],
      valor: [0],
      tarifa: [0],
      estado: 1
    });
  }

  private createFormCda(): FormGroup {
    return this.fb.group({
      placa: [''],
      idcda: [''],
      centrocda: [''],
      fechacda: [''],
      vcda: [''],
      estado: 1
    });
  }

  private createFormExtintor(): FormGroup {
    return this.fb.group({
      placa: [''],
      idextintor: ['', Validators.required],
      frecarga: [null, Validators.required],
      vrecarga: [null, Validators.required],
    });
  }

  private createFormBimestral(): FormGroup {
    return this.fb.group({
      placa: [''],
      centro_diagnostico: [''],
      revision_aprobada: [''],
      ultima_revision: [''],
      proxima_revision: [''],
      estado: 1
    });
  }

  private createFormContractual(): FormGroup {
    return this.fb.group({
      placa: [''],
      aseguradoraRCC: [''],
      intermediariaRCC: [''],
      fecha_expedicionRCC: [''],
      fecha_vencimientoRCC: [''],
      numeroRCC: [''],
      estado: 1
    });
  }

  private createFormExtracontractual(): FormGroup {
    return this.fb.group({
      placa: [''],
      aseguradoraRCE: [''],
      intermediariaRCE: [''],
      fecha_expedicionRCE: [''],
      fecha_vencimientoRCE: [''],
      numeroRCE: [''],
      estado: 1
    });
  }

  private createFormTodoriesgo(): FormGroup {
    return this.fb.group({
      placa: [''],
      aseguradoraTD: [''],
      intermediariaTD: [''],
      fecha_expedicionTD: [''],
      fecha_vencimientoTD: [''],
      numeroTD: [''],
      estado: 1
    });
  }

  private createFormEmpresa(): FormGroup {
    return this.fb.group({
      nit: [''],
      digito: [''],
      nombre: [''],
      direccion: [''],
      ciudad: [''],
      telefono: ['', [Validators.maxLength(10)]],
      celular: ['', [Validators.maxLength(10)]],
      email: [''],
      observaciones: [''],
      eps: ['true'],
      arl: ['true'],
      afp: ['true'],
      ces: ['true'],
      ccf: ['true'],
      bancos: ['true'],
      transporte: ['true'],
      colegio: ['true'],
      cda: ['true'],
      taller: ['true'],
      eds: ['true'],
      contratista: ['true'],
      proveedor: ['true'],
      aseguradora: ['true'],
      almacen: ['true'],
      serviteca: ['true']
    });
  }

  private createFormClase(): FormGroup {
    return this.fb.group({
      tipos: [''],
      estado: ['1'],
    });
  }

  private createFormRunt(): FormGroup {
    return this.fb.group({
      documentType: ['CC', Validators.required],
      documentNumber: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      plate: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9]+$')]],
    });
  }

  private createFormRodamiento(): FormGroup {
    return this.fb.group({
      placa: [''],
      tipo_rodamiento: [''],
      numero_rodamiento: [''],
      fecha_expedicion: [''],
      fecha_vencimiento: [''],
      estado: 1
    });
  }

  private setupRodamientoVencimiento(): void {
    const calcularVencimiento = () => {
      const tipo = this.formNuevo.get('tipo_rodamiento')?.value;
      const fechaStr = this.formRodamiento.get('fecha_expedicion')?.value;
      if (!tipo || !fechaStr) return;

      const fecha = new Date(fechaStr);
      const nuevaFecha = new Date(fecha);

      switch (tipo) {
        case 'DIARIA':    nuevaFecha.setDate(nuevaFecha.getDate() + 1);             break;
        case 'SEMANAL':   nuevaFecha.setDate(nuevaFecha.getDate() + 7);             break;
        case 'MENSUAL':   nuevaFecha.setMonth(nuevaFecha.getMonth() + 1);           break;
        case 'SEMESTRAL': nuevaFecha.setMonth(nuevaFecha.getMonth() + 6);           break;
        case 'ANUAL':
          nuevaFecha.setFullYear(nuevaFecha.getFullYear() + 1);
          nuevaFecha.setDate(nuevaFecha.getDate() - 1);
          break;
      }

      this.formRodamiento.get('fecha_vencimiento')?.setValue(
        nuevaFecha.toISOString().substring(0, 10), { emitEvent: false }
      );
    };

    this.formNuevo.get('tipo_rodamiento')?.valueChanges.subscribe(() => calcularVencimiento());
    this.formRodamiento.get('fecha_expedicion')?.valueChanges.subscribe(() => calcularVencimiento());
  }

  private getTelefonoValidators(): ValidatorFn[] {
    return [
      Validators.min(1000000),
      Validators.max(9999999999),
      Validators.maxLength(10),
      Validators.pattern(/^\d{0,10}$/)
    ];
  }
  // ── Función auxiliar para enfocar y mostrar alertas ───────────────────
  private scrollToField(
    panelId: string,
    inputRef: ElementRef | any,
    campo: string,
    mensaje: string
  ) {
    this.errores[campo] = mensaje;

    // Asegurar que el panel esté expandido
    if (!this.accordion.isExpanded(panelId)) {
      this.accordion.toggle(panelId);
    }

    // Mostrar el mensaje inmediatamente
    Swal.fire('Campo requerido', mensaje, 'info');

    // Enfocar el campo si existe
    if (inputRef) {
      const elemento = inputRef.nativeElement ?? inputRef;
      if (elemento && typeof elemento.focus === 'function') {
        // Esperar un poco si es necesario por el renderizado del DOM
        setTimeout(() => elemento.focus(), 50);
      }
    }
  }

  private validarCampoExt(
    servicio: number,
    valor: any,
    control: AbstractControl,
    inputRef: ElementRef,
    mensaje: string
  ): boolean {
    if ((servicio === 1) && (valor == null || valor < 1)) {
      control.markAsTouched();
      control.setErrors({ required: true });

      this.active2 = 2;

      if (!this.accordion.isExpanded('static-7')) {
        this.accordion.toggle('static-7');
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          inputRef?.nativeElement?.focus();
        });
        Swal.fire('Campo requerido', mensaje, 'info');
      });

      return false;
    }
    return true;
  }
  buscarPropietario(term: string, item: any): boolean {
    if (!term) return true;
    term = term.toLowerCase();

    const nombreCompleto = `${item.primernombre} ${item.segundonombre} ${item.papellidos} ${item.seapellidos}`.toLowerCase();
    const cedula = (item.cedula || '').toString().toLowerCase();

    return nombreCompleto.includes(term) || cedula.includes(term);
  }

  onPropietarioChange(cedulaSeleccionada: any): void {
    const titularControl = this.formNuevo.get('titular');
    if (!cedulaSeleccionada) {
      titularControl?.setValue('');
      return;
    }

    const cedula =
      typeof cedulaSeleccionada === 'object'
        ? cedulaSeleccionada?.cedula
        : cedulaSeleccionada;

    const propietario =
      typeof cedulaSeleccionada === 'object' && cedulaSeleccionada?.cedula
        ? cedulaSeleccionada
        : this.propietarios?.find((p: any) => String(p.cedula) === String(cedula));

    if (!propietario) {
      titularControl?.setValue('');
      return;
    }

    const nombreCompleto = [
      propietario.primernombre,
      propietario.segundonombre,
      propietario.papellidos,
      propietario.seapellidos
    ]
      .filter((valor: any) => !!valor)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();

    titularControl?.setValue(nombreCompleto);
  }

  private cargarCiudades(): void {
    forkJoin({
      municipios: this.dataService.getDatos(),
    }).subscribe(
      (resultados) => {
        this.municipios = resultados.municipios;
      },
      (error) => this.handleError(error)
    );
  }

  private handleError(error: any): void {
    console.error('Error al obtener datos:', error);
  }

  limitarLongitud(event: Event, max: number) {
    const input = event.target as HTMLInputElement;
    if (input.value.length > max) {
      input.value = input.value.slice(0, max);
      // Actualiza el FormControl asociado
      const controlName = input.getAttribute('formControlName');
      if (controlName) {
        this.formEmpresa.get(controlName)?.setValue(input.value);
      }
    }
  }
  
  validarTipoEmpresaSeleccionado(): boolean {
    const controles = this.formEmpresa.controls;
    const algunoSeleccionado = Object.keys(controles).some(key => controles[key].value === true);
    if (!algunoSeleccionado) {
      this.mostrarAlerta("Campo requerido", "Selecciona al menos un tipo de empresa", "info");
    }
    return algunoSeleccionado;
  }

  /**
   * Obtiene la fecha actual en formato YYYY-MM-DD (zona horaria local de Colombia)
   * @returns string - Fecha actual formateada
   */
  private getTodayDate(): string {
    const today = new Date();
    
    // Obtener la fecha local ajustada para Colombia (UTC-5)
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  /**
   * Configura la validación delayed para el campo de afiliación
   */
  private setupAfiliacionValidation(): void {
    const afiliacionControl = this.formNuevo.get('afiliacion');
    if (afiliacionControl) {
      afiliacionControl.setValidators([this.validarFechaAfiliacion.bind(this)]);
      afiliacionControl.updateValueAndValidity();
    }
  }

  /**
   * Maneja el cambio de fecha de afiliación para permitir entrada por tecladoAbstractControl
   * @param event - Event del input
   */
  onFechaAfiliacionChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value;
    const afiliacionControl = this.formNuevo.get('afiliacion');
    
    if (afiliacionControl) {
      // Marcar como touched para activar validaciones visuales
      afiliacionControl.markAsTouched();
      
      // Permitir que el usuario escriba la fecha
      afiliacionControl.setValue(valor, { emitEvent: false });
      
      // Validar después de un pequeño delay para permitir completar la escritura
      setTimeout(() => {
        afiliacionControl.updateValueAndValidity();
      }, 300);
    }
  }

  /**
   * Maneja el cambio de fecha de licencia de tránsito
   * Valida que no sea futura y calcula fechacda si es necesario
   * @param event - Event del input
   */
  onFechaLicenciaChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value;
    const fechalictControl = this.formNuevo.get('fechalict');
    
    if (!fechalictControl) return;

    // Si no hay valor, limpiar errores y campos relacionados
    if (!valor) {
      fechalictControl.setErrors(null);
      this.formCda.get('fechacda')?.setValue(null);
      this.formCda.get('vcda')?.setValue(null);
      return;
    }

    // Marcar como touched para activar validaciones visuales
    fechalictControl.markAsTouched();
    
    // Verificar que la fecha sea válida (formato completo YYYY-MM-DD)
    const fechaLicencia = new Date(valor);
    if (isNaN(fechaLicencia.getTime()) || valor.length < 10) {
      // Si la fecha está incompleta o es inválida, no validar aún
      return;
    }

    const fechaActual = new Date();
    
    // Normalizar fechas para comparación
    fechaActual.setHours(23, 59, 59, 999);
    fechaLicencia.setHours(0, 0, 0, 0);

    // Validar si es fecha futura
    if (fechaLicencia > fechaActual) {
      console.log('Fecha licencia futura detectada - bloqueando');
      fechalictControl.setErrors({ 'fechaLicenciaFutura': { valor, actual: fechaActual } });
      
      // Limpiar campos relacionados
      this.formCda.get('fechacda')?.setValue(null);
      this.formCda.get('vcda')?.setValue(null);
      return;
    }

    // Limpiar errores si la fecha es válida
    fechalictControl.setErrors(null);

    // Si pasa la validación, calcular lógica de CDA
    const fechaLimite = new Date(fechaActual);
    fechaLimite.setFullYear(fechaLimite.getFullYear() - 2);
    fechaLimite.setHours(0, 0, 0, 0);

    // Calcular la antigüedad en años
    const antiguedadMilisegundos = fechaActual.getTime() - fechaLicencia.getTime();
    const antiguedadAnios = antiguedadMilisegundos / (1000 * 60 * 60 * 24 * 365.25);

    console.log('Antigüedad de la licencia:', {
      fechaLicencia: valor,
      antiguedadAnios: antiguedadAnios.toFixed(2),
      esMayorA2Anios: antiguedadAnios > 2
    });

    // Si la fecha es reciente (menos de 2 años), calcular fechacda
    if (fechaLicencia >= fechaLimite) {
      // Usar directamente el valor string sin convertir a Date para evitar problemas de zona horaria
      this.formCda.get('fechacda')?.setValue(valor);
      console.log('Fecha CDA igual a fecha de licencia:', valor);
      
      // Calcular vcda (fecha licencia + 2 años)
      const fechaVcda = new Date(valor);
      fechaVcda.setFullYear(fechaVcda.getFullYear() + 2);
      const fechaVcdaStr = fechaVcda.toISOString().substring(0, 10);
      this.formCda.get('vcda')?.setValue(fechaVcdaStr);
      this.formCda.get('idcda')?.setValue(0);
      console.log('Fecha vcda (licencia + 2 años):', fechaVcdaStr);
      this.formCda.get('centrocda')?.setValue('22222222');
    } else {
      // Si la fecha es antigua (más de 2 años)
      this.formCda.get('fechacda')?.setValue(null);
      this.formCda.get('vcda')?.setValue(null);
       this.formCda.get('centrocda')?.setValue(null);
       this.formCda.get('idcda')?.setValue(null);
      console.log('Fecha licencia > 2 años - campos CDA limpiados');
      
     } // Forzar actualización de validación
    fechalictControl.updateValueAndValidity();
  }

  /**
   * Validador personalizado para fecha de afiliación
   * @param control - AbstractControl
   * @returns ValidationErrors | null
   */
  private validarFechaAfiliacion(control: AbstractControl): {[key: string]: any} | null {
    const valor = control.value;
    
    // Si no hay valor, no es error (campo opcional)
    if (!valor) {
      return null;
    }

    // Verificar que la fecha sea válida antes de continuar
    const fechaAfiliacion = new Date(valor);
    
    // Si la fecha no es válida, no mostrar error para permitir que el usuario termine de escribir
    if (isNaN(fechaAfiliacion.getTime())) {
      return null;
    }

    const fechaActual = new Date();
    const fechaMinima = new Date('1990-01-01'); // Fecha mínima permitida

    // Resetear las horas para comparar solo fechas
    fechaActual.setHours(23, 59, 59, 999);
    fechaAfiliacion.setHours(0, 0, 0, 0);
    fechaMinima.setHours(0, 0, 0, 0);

    // Debug: Log para verificar que la validación se ejecuta
    console.log('Validando fecha afiliación:', {
      valor,
      fechaAfiliacion,
      fechaActual,
      esFutura: fechaAfiliacion > fechaActual,
      esMuyAntigua: fechaAfiliacion < fechaMinima
    });

    if (fechaAfiliacion > fechaActual) {
      //console.log('Error: Fecha futura detectada');
      return { 'fechaFutura': { valor: valor, actual: fechaActual } };
    }

    if (fechaAfiliacion < fechaMinima) {
     // console.log('Error: Fecha muy antigua detectada');
      return { 'fechaMuyAntigua': { valor: valor, minima: fechaMinima } };
    }

    //console.log('Fecha válida');
    return null;
  }

  /**
   * Validador personalizado para fecha de licencia de tránsito
   * Solo valida que no sea fecha futura (permite fechas antiguas)
   * @param control - AbstractControl
   * @returns ValidationErrors | null
   */
  private validarFechaLicencia(control: AbstractControl): {[key: string]: any} | null {
    const valor = control.value;
    
    // Si no hay valor, no es error (campo opcional)
    if (!valor) {
      return null;
    }

    // Verificar que la fecha sea válida antes de continuar
    const fechaLicencia = new Date(valor);
    
    // Si la fecha no es válida, no mostrar error
    if (isNaN(fechaLicencia.getTime())) {
      return null;
    }

    const fechaActual = new Date();

    // Resetear las horas para comparar solo fechas
    fechaActual.setHours(23, 59, 59, 999);
    fechaLicencia.setHours(0, 0, 0, 0);

    console.log('Validando fecha licencia:', {
      valor,
      fechaLicencia,
      fechaActual,
      esFutura: fechaLicencia > fechaActual
    });

    // Solo validar que no sea fecha futura
    if (fechaLicencia > fechaActual) {
      console.log('Error: Fecha licencia futura detectada');
      return { 'fechaLicenciaFutura': { valor: valor, actual: fechaActual } };
    }

    console.log('Fecha licencia válida');
    return null;
  }

  private normalizarFechaRunt(fecha: string | null | undefined): string {
    if (!fecha) {
      return '';
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
      return fecha;
    }

    const partes = fecha.split('/');
    if (partes.length === 3) {
      const [dia, mes, anio] = partes;
      return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
    }

    return '';
  }
}
